<template>
  <div class="chat-wrap"  v-html="videoHtml" @blur="reloadDiv" @focus="reloadDiv"></div>
</template>

<script type="text/ecmascript-6">
  import utilApi from '@/api/utilNoMessage'
  import axios from "axios";
  export default {
    name: 'chatWrap',
    data () {
      return {
        videoHtml:'',
        loginUserId:'123456',
        loginUserName:'游客',
      }
    },
    mounted(){
      let this_ = this
      if(this_.global.isLogin) {
        this_.loginUserId = this_.global.userModel.id
        this_.loginUserName = this_.global.userModel.name

        utilApi.getKeFu(null).then( re =>{
          let html = '<iframe id="keFuIframe" style="width: 100%; height: 100%" src="http://kefu.renrendonghua.com/client.jsp?visitorName='+this.loginUserName+'&visitorId='+this.loginUserId+'&visitorSite=rrdh" allowfullscreen="true" frameborder="0" ></iframe>'
          this_.getHtml(html);
        }).catch(err =>{
          this_.getHtml("客服系统尚未启动");
        })
      }


    },
    methods: {
      getHtml(html){
        this.videoHtml = html
      },
      reloadDiv(){
        console.log("reloadDiv============================================================================>")
      }
    }
  }
</script>

<style lang="less" scoped>
  .chat-wrap {
    width: 100%;
    height: 100%;
  }
</style>
